import Cookies from 'js-cookie'

const initFooterAccessibility = () => {
    const accessibilityContainer = document.querySelector('.accessibility-container');
    document.querySelector('.accessibility-btn').addEventListener('click', () => {
        accessibilityContainer.classList.add('visible')
    });

    document.querySelector('.accessibility-arrow').addEventListener('click', () => {
        accessibilityContainer.classList.remove('visible')
    });
}

const initFontPreference = () => {
    const front = document.querySelector('#front');
    const switchBtn = document.querySelector('.accessibility-font-btn .accessibility-switch')
    document.querySelector('.accessibility-font-btn').addEventListener('click', () => {
        if (Cookies.get('activateDyslexic', { domain: app.domain, secure: true }) === 'true') {
            Cookies.remove('activateDyslexic', { expires: 7, domain: app.domain, secure: true });
            front.classList.remove('font-open-dyslexic');
            switchBtn.classList.remove('on');
        } else {
            Cookies.set('activateDyslexic', 'true', { expires: 7, domain: app.domain, secure: true });
            front.classList.add('font-open-dyslexic');
            switchBtn.classList.add('on');
        }
    });
}

const initAnimationPreference = () => {
    const switchBtn = document.querySelector('.accessibility-animation-btn .accessibility-switch');
    document.querySelector('.accessibility-animation-btn').addEventListener('click', () => {
        if (Cookies.get('deactivateAnimation', { domain: app.domain, secure: true }) === 'true') {
            Cookies.remove('deactivateAnimation', { expires: 7, domain: app.domain, secure: true });
            switchBtn.classList.add('on');
        } else {
            Cookies.set('deactivateAnimation', 'true', { expires: 7, domain: app.domain, secure: true });
            switchBtn.classList.remove('on');
        }
    });
}

export default class footer {
    static init() {
        initFontPreference();
        initFooterAccessibility();
        initAnimationPreference();
    }
}
